var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.4999 29.3333L71.0079 79.7937H28.5714L18.2539 29.3333C18.4047 17.6508 26.984 10.0159 34.1507 5.66667C38.6903 2.92063 43.2459 1.09524 46.2538 0.0634935V37.381C44.4284 38.5476 43.2222 40.5873 43.2222 42.9127C43.2222 46.5397 46.1587 49.4841 49.7936 49.4841C53.4285 49.4841 56.3649 46.5397 56.3649 42.9127C56.3649 40.5873 55.1587 38.5476 53.3333 37.381V0C56.3571 1.01587 61.0554 2.85714 65.7062 5.66667C72.9126 10.0079 81.4999 17.6508 81.4999 29.3333Z",
    fill: "#FC9194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8175 84.8412H23.7461V100H75.8175V84.8412Z",
    fill: "#FC9194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.b13d0f7150dfca53d1bff87e92dd8a21.svg";
export { ForwardRef as ReactComponent };